import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Input, Select, InputNumber, Button} from 'antd'
import {withTranslation} from 'react-i18next'

const {TextArea} = Input

@inject('permissionManagementStore')
@observer
class FormModal extends Component {
  state = {}
  formRef = React.createRef()

  componentDidMount() {
    const {permissionManagementStore, title} = this.props
    const {detailsObj} = permissionManagementStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        name: detailsObj.name,
        key: detailsObj.key,
        description: detailsObj.description,
        method: detailsObj.method,
        path: detailsObj.path,
        parentId: detailsObj.parentId,
      })
    } else {
      this.formRef.current.setFieldsValue({
        name: '',
        key: '',
        description: '',
        method: '',
        path: '',
        parentId: '',
      })
    }
  }

  handleOk = () => {
    const {permissionManagementStore, handleCancel, title} = this.props
    const {detailsObj} = permissionManagementStore
    this.formRef.current.validateFields().then(fieldsValue => {
      if (title === 'edit') {
        permissionManagementStore.onEditPermissionAction({...fieldsValue, status: true}, detailsObj.id)
      } else {
        permissionManagementStore.onChangePageNo()
        permissionManagementStore.onAddPermissionAction({...fieldsValue, status: true})
      }
      handleCancel()
    }).catch(err => {})

  }

  render() {
    const {permissionManagementStore, addModalVisible, handleCancel, title, t} = this.props
    const {permissionType} = permissionManagementStore
    return (
      <>
        <Modal
          title={permissionType === 'OPERATION' && title === 'edit' ? `${t(`permissionManagement.editPermission`)}` : permissionType === 'OPERATION' ? `${t(`permissionManagement.addPermission`)}` : permissionType === 'API' && title === 'edit' ? `${t(`permissionManagement.editApi`)}` : permissionType === 'API' ? `${t(`permissionManagement.addApi`)}` : permissionType === 'MENU' && title === 'edit' ? `${t(`permissionManagement.editMenu`)}` : `${t(`permissionManagement.addMenu`)}`}
          closable={true}
          onCancel={handleCancel}
          visible={addModalVisible}
          // onOk={this.handleOk}
          // onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            {permissionType === 'OPERATION' ? <Row justify="start" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="name" label={t(`permissionManagement.permissionName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.permissionName`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="key" label={t(`permissionManagement.permissionKey`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.permissionKey`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="description" label={t(`permissionManagement.description`)}
                           rules={[{
                             required: false,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.description`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <TextArea rows={4}/>
                </Form.Item>
              </Col>
            </Row> : permissionType === 'API' ? <Row justify="start" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="name" label={t(`permissionManagement.apiName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.apiName`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="key" label={t(`permissionManagement.apiKey`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.apiKey`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="method" label={t(`permissionManagement.requestMethod`)}
                           rules={[{required: true, message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.requestMethod`)}`,}]}>
                  <Select placeholder={t(`general.pleaseEnter`)} allowClear>
                    <Select.Option key="GET" value="GET">GET</Select.Option>
                    <Select.Option key="POST" value="POST">POST</Select.Option>
                    <Select.Option key="PUT" value="PUT">PUT</Select.Option>
                    <Select.Option key="DELETE" value="DELETE">DELETE</Select.Option>
                    <Select.Option key="OPTIONS" value="OPTIONS">OPTIONS</Select.Option>
                    <Select.Option key="PATCH" value="PATCH">PATCH</Select.Option>
                    <Select.Option key="HEAD" value="HEAD">HEAD</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="path" label={t(`permissionManagement.requestPath`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.requestPath`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="description" label={t(`permissionManagement.description`)}
                           rules={[{
                             required: false,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.description`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <TextArea rows={4}/>
                </Form.Item>
              </Col>
            </Row> : <Row justify="start" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="name" label={t(`permissionManagement.menuName`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.menuName`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="key" label={t(`permissionManagement.menuKey`)}
                           rules={[{
                             required: true,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.menuKey`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <Input maxLength={100} placeholder={t(`general.pleaseEnter`)}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="parentId" label={t(`permissionManagement.parentId`)}
                           rules={[{required: false, message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.parentId`)}`,}]}>
                  <InputNumber min={0} max={10000} style={{width: '100%'}}/>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="description" label={t(`permissionManagement.description`)}
                           rules={[{
                             required: false,
                             message: `${t(`general.pleaseEnter`)} ${t(`permissionManagement.description`)} ${t(`general.withoutSpecialChats`)}`,
                             pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                           }]}>
                  <TextArea rows={4}/>
                </Form.Item>
              </Col>
            </Row>}
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
